import { API } from 'aws-amplify'

const getStats = async () => {
  return await API.get('client', `/stats`, {})
}

export const StatsService = {
  getStats,
}
